// extracted by mini-css-extract-plugin
export default {"security-info__icon-container":"style_security-info__icon-container__05yQB","security-info__text":"style_security-info__text__elKQE"};